export default "__VITE_PUBLIC_ASSET__a390b699__"